import { safeDefine } from '../../registration/safe-define';
import { ControlsGroupElement } from '../../ui/controls/group';

safeDefine(ControlsGroupElement);

declare global {
  interface HTMLElementTagNameMap {
    [ControlsGroupElement.tagName]: ControlsGroupElement;
  }
}
